import React, { Component } from 'react';
import withErrorCatcher from '../Common/withErrorCatcher.js'
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose'
import { connect } from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress';
import AppContent from '../../components/App/appContent';
import PageContentWrapper from '../../components/App/PageComponents/pageContentWrapper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// OrganizationAdminly some reset
const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'

    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
});

class OrganizationAdmin extends Component {
    state = {
        isAdmin: false,
        isLoading: true
    }

    componentDidMount(){
        const { adminService, userData } = this.props;

        adminService.isAdmin(userData.profileData.auth0_id).then( res => {
            this.setState({ isAdmin: res, isLoading: false })
        })
    }

    render() {
        const { classes } = this.props;

        const spinner = <div data-intrcm-id="organizationAdmin_m3wyjfk7" className={classes.spinner}>
            <CircularProgress className={classes.progress} />
        </div>
        let content = spinner;

        if(!this.state.isLoading) {     
            if (this.state.isAdmin){
                content = this.props.children
            }
            else{
                content = <AppContent >
                    <PageContentWrapper >
                        <Grid  spacing={16}>
                                <Typography variant="title" style={{ marginBottom: '15px' }}>
                                    Not authorized
                                </Typography>
                            </Grid>
                    </PageContentWrapper>
                </AppContent>
            }
        }

        return content;
    }
}

const mapStateToProps = (state) => ({
    ...state.services,
    userData: state.userData,
})

const mapDispatchToProps = dispatch => {
    return { dispatch: dispatch }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(OrganizationAdmin);
